import {v4 as uuid } from 'uuid';

function setFieldErrors (err) {
    this.fieldErrors = {
        ...err,
    };
    this.observed.fieldErrors = uuid();
}

export default setFieldErrors;